import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
// import { handleAlert, handleLoading, settimeout } from "components/utils/comm";
import i18n from "locales/i18n";
import { IResponse } from "./api";
import { alertControl, loadControl, sessionTimeOut } from "util/commAction";

const langCd = i18n.language;

// 재시도 관련 커스텀 옵션 확장
interface RetryConfig extends InternalAxiosRequestConfig {
  _retryCount?: number;
  _maxRetries?: number;
  _shouldRetry?: boolean;
}

// 딜레이 함수
const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

//공통 인스턴스 생성
// base - url: https://dev-engine.rmframe.com:3643/
// https://uploadbooking.synology.me:3643/
const axiosInstance = axios.create({
  baseURL: "/app/api/",
  timeout: 5000,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
    "Accept-Language": langCd,
  },
});

//요청 인터셉터
axiosInstance.interceptors.request.use(
  (config: RetryConfig) => {
    // console.log("config", config);

    //토큰 처리

    // 재시도 관련 기본값 설정
    config._retryCount = config._retryCount ?? 0;
    config._maxRetries = config._maxRetries ?? 3;
    config._shouldRetry = config._shouldRetry ?? true;
    return config;
  },
  (error: AxiosError) => Promise.reject(error)
);

//응답 인터셉터
axiosInstance.interceptors.response.use(
  (response: AxiosResponse<any, any>) => {
    setTimeout(() => {
      loadControl({
        isLoading: false,
        text: "Loading",
      });
    }, 500);

    console.log("응답 인터셉터 response", response);

    //세션아웃
    if (response.data?.code === -200) {
      localStorage.removeItem("pages");
      alertControl({
        isOpen: true,
        inner: response.data?.message ?? "",
        click: () => {
          // sessionTimeOut 처리
          sessionTimeOut();
        },
      });
    }

    //네트워크 성공 & 에러발생
    if (response.data?.code !== 200) {
      const { status, data } = response as IResponse;
      if (status?.code === -1) {
        setTimeout(() => {
          alertControl({
            isOpen: true,
            inner: status.message,
            innerHtml: null,
          });
        }, 500);
      }
    }

    return response;
  },
  async (error: AxiosError) => {
    console.log("응답 인터셉터 error", error);

    const config = error.config as RetryConfig;
    try {
      const isTimeout = error.code === "ECONNABORTED";
      const isNetworkError = !error.response;
      const shouldRetry =
        (isTimeout || isNetworkError) &&
        config._shouldRetry &&
        (config._retryCount ?? 0) < (config._maxRetries ?? 0);

      //타암아웃 재시도
      if (shouldRetry) {
        config._retryCount = (config._retryCount ?? 0) + 1;
        const waitTime = 500;
        console.warn(
          `🔁 재시도 ${config._retryCount}/${config._maxRetries} (대기 ${waitTime}ms)`
        );
        await delay(waitTime);
        return axiosInstance(config);
      }
      if (error.response) {
        const { status, data } = error.response;

        //에러코드 관련 에러문구
        switch (status) {
          case 400:
            alert("잘못된 요청입니다.");
            break;
          case 401:
            alert("인증이 필요합니다.");
            break;
          case 404:
            alert("api 기본URL 확인하여 주세요");
            break;
          case 500:
            // alert("서버 에러가 발생했습니다."); //
            console.log("서버에러");
            break;
          default:
            alert("알 수 없는 에러가 발생했습니다.");
        }

        loadControl({
          isLoading: false,
        });
      } else {
        console.error("🚫 네트워크 오류 또는 응답 없음:", error.message);
      }
    } catch (err) {
      console.log("응답 인터셉터 내부 에러 처리중 , 예외 발생", err);
    }
  }
);

export default axiosInstance;
